/* ------------------------------------------------------------
   BEZIKA — COLOUR SWATCHES
   File: assets/bezika-swatches.js
   ------------------------------------------------------------
   Pressing a circle on a product card shows that colour's own
   photograph, and points the card at that variant so the product
   page - and the quick add button, where there is one - open on
   the colour that was chosen.

   The card is found by climbing from the circles rather than by
   a class name, because every section names its card something
   different. The climb stops at the first ancestor holding a
   picture, and gives up after a few steps rather than reaching
   out into the grid and changing a neighbour's card.
   ------------------------------------------------------------ */

if (!customElements.get('bezika-swatches')) {
  customElements.define(
    'bezika-swatches',
    class BezikaSwatches extends HTMLElement {
      connectedCallback() {
        this.dots = Array.from(this.querySelectorAll('[data-bzk-sw]'));
        if (this.dots.length === 0) return;

        this.card = this.findCard();
        this.image = this.card ? this.card.querySelector('img') : null;

        // Nothing to show a colour in. The circles still say what the
        // product comes in, so they are left alone rather than removed.
        if (!this.image) {
          this.dots.forEach((dot) => {
            dot.disabled = true;
            dot.style.cursor = 'default';
          });
          return;
        }

        this.dots.forEach((dot) => {
          dot.setAttribute('aria-pressed', 'false');
          dot.addEventListener('click', (event) => {
            // The circles sit inside the link that wraps the card in some
            // sections, and a press here means "show me this", not "open
            // the product page".
            event.preventDefault();
            event.stopPropagation();
            this.choose(dot);
          });
        });
      }

      findCard() {
        var node = this.parentElement;
        var steps = 0;

        while (node && steps < 5) {
          if (node.tagName === 'LI' || node.tagName === 'ARTICLE') return node;
          if (node.querySelector('img')) return node;
          node = node.parentElement;
          steps += 1;
        }
        return null;
      }

      choose(dot) {
        this.dots.forEach((other) => {
          other.setAttribute('aria-pressed', other === dot ? 'true' : 'false');
        });

        var url = dot.dataset.image;
        if (url) {
          // The width hints described the picture that was there before.
          // They are dropped so the browser takes the one URL given here,
          // rather than picking a size from a list this image is not in.
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
          this.image.src = url;
        }

        var id = dot.dataset.variant;
        if (!id) return;

        // The card's links carry the colour, so the product page opens on
        // it. Only product links: a card may also hold a collection link.
        this.card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          try {
            var next = new URL(link.href, window.location.origin);
            next.searchParams.set('variant', id);
            link.href = next.pathname + next.search;
          } catch (error) {
            /* A relative or unusual href: leave it as it was. */
          }
        });

        // And the quick add button, where the section has one, so the
        // colour on screen is the colour that goes into the cart.
        this.card.querySelectorAll('[data-variant-id]').forEach((button) => {
          button.dataset.variantId = id;
        });
      }
    }
  );
}
